module.exports = __webpack_public_path__ + "img/ModernCosmetics.0a876450.jpg";